import { Box, Flex, Text } from "@familyzone/component-library";
import React, { FC, ReactChild } from "react";

interface SectionHeadingProps {
  title: string;
  icon?: ReactChild;
  "aria-level"?: number;
}

const SectionHeading: FC<SectionHeadingProps> = ({ title, icon, "aria-level": ariaLevel }) => {
  return (
    <Box borderRadius="sm" p="sp12" backgroundColor="neutrals.20">
      <Flex gap="sp8" alignItems="center">
        <Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" color="text.paragraph.regular" role="heading" aria-level={ariaLevel}>
          {title}
        </Text>
        {icon}
      </Flex>
    </Box>
  );
};

export default SectionHeading;
